import React, { useEffect } from "react";
import contact from "../assets/images/contact.svg";
import AOS from "aos";
import "aos/dist/aos.css";

const contactList = [
  {
    detail: "+62 8988 6945 558",
    title: "WhatsApp",
  },
  {
    detail: "rfirhan99@gmail.com",
    title: "Email",
  },
];

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const renderedContact = contactList.map(({ detail, title }) => {
    return (
      <div
        className="w-4/5 lg:w-4/5 xl:w-11/12 flex rounded-sm shadow-md justify-center xl:justify-center lg:px-3 py-3 mb-3"
        style={{ backgroundColor: "#F4F4F4" }}
        key={title}
      >
        <h3 className="font-montserrat text-sm font-semibold mt-auto">
          {detail}
        </h3>
      </div>
    );
  });

  return (
    <div
      className="flex flex-col md:flex-row lg:flex-row lg:px-10 xl:justify-center items-center md:px-8 md:justify-center pb-3 w-full"
      data-aos="fade-right"
      id="contact"
    >
      <img
        src={contact}
        alt="Contact"
        className="w-10/12 lg:w-2/5 md:w-1/2 lg:order-1 xl:w-1/3"
      />
      <div className="flex w-full flex-col items-center lg:flex lg:flex-col lg:items-center md:w-1/2 lg:w-3/5 xl:w-1/3 lg:order-2">
        <h3 className="font-semibold lg:text-center font-montserrat text-2xl mb-3">
          Contact Me
        </h3>
        {renderedContact}
      </div>
    </div>
  );
};

export default Contact;
